/**
 * Shipping Address Manager
 * Manages shipping address collection, validation, and storage
 */

// יישובים שאינם בתחום המשלוח
const NON_DELIVERY_SET = new Set([
  'אבו גווייעד (שבט)', 'אבו גווייעד',
  'אבו סריחאן (שבט)', 'אבו סריחאן',
  'אבו עבדון (שבט)', 'אבו עבדון',
  'אבו עמאר (שבט)', 'אבו עמאר',
  'אבו עמרה (שבט)', 'אבו עמרה',
  'אבו קורינאת (שבט)', 'אבו קורינאת',
  'אבו קרינאת (יישוב)', 'אבו קרינאת',
  'אבו רוקייק (שבט)', 'אבו רוקייק',
  'אבו תלול', 'אום אל-קוטוף', 'אום בטין',
  'אטרש (שבט)', 'אטרש', 'איבים', 'אילות', 'אילת',
  'אל סייד', 'אל-עזי', 'אל-עריאן',
  'אסד (שבט)', 'אסד', 'אפיניש (שבט)', 'אפיניש',
  'אתגר', 'באר אורה', 'ביר הדאג', 'גרופית', 'דחי',
  'דייר ראפאת', 'דמיידה', 'דריגאת',
  'הוואשלה (שבט)', 'הוואשלה', 'הוזייל (שבט)', 'הוזייל',
  'זבארגה (שבט)', 'זבארגה', 'חואלד', 'חולית', 'חוסנייה', 'חורה', 'חמאם',
  'יטבתה', 'ייטב', 'יסודות', 'כחלה', 'כישור', 'כמאנה', 'כמהין', 'כסלון',
  'כעביה-טבאש-חגאגרה', 'כפר זוהרים', 'כפר רוזנואלד (זרעית)', 'כפר רוזנואלד',
  'מנשית זבדה', 'מסעודין אל-עזאזמה', 'משכיות', 'משען',
  'נאעורה', 'נווה חריף', 'ניצנה (קהילת חינוך)', 'ניצנה', 'ניצני סיני', 'נערן',
  'נצאצרה (שבט)', 'נצאצרה', 'סואעד (חמירה)', 'סואעד (כמאנה) (שבט)', 'סואעד',
  'סייד (שבט)', 'סייד', 'סמר', 'סנסנה', 'סעוה',
  'עוקבי (בנו עוקבה)', 'עוקבי', 'עזוז',
  'עטאוונה (שבט)', 'עטאוונה', 'עין קנייא', 'עין ראפה', 'עיר אובות', 'עראמשה', 'ערב אל נעים', 'ערערה-בנגב',
  'קבועה (שבט)', 'קבועה', 'קודייראת א-צאנע(שבט)', 'קודייראת א-צאנע', 'קוואעין (שבט)', 'קוואעין',
  'ראס אל-עין', 'ראס עלי', 'רומאנה', 'רומת הייב', 'שייח דנון', 'שעב',
  'תראבין א-צאנע (שבט)', 'תראבין א-צאנע(ישוב)', 'תראבין א-צאנע',
  'עילוט', 'אבו רובייעה (שבט)', 'אבו רובייעה', 'אעצם (שבט)', 'אעצם',
  'גנאביב (שבט)', 'גנאביב', 'קצר א-סר', 'חוגייראת (דהרה)', 'חוגייראת',
  'טייבה (בעמק)', 'תל ציון', 'אביגיל', 'בית חוגלה', 'גבעות הרואה', 'משמר יהודה', 'עשהאל', 'שחרית', 'בר כוכבא',
  'אדוריים', 'עין נקובא', 'אחיה', 'חרשה', 'טל מנשה', 'מגרון', 'נופי פרת', 'עדי עד', 'שבות רחל',
  'איבי הנחל', 'גודר', 'כרם רעים', 'לשם', 'נריה', 'פרשים', 'שא-נור',
  'בתרון', 'גבעות', 'חומש', 'יונדב', 'קדם ערבה', 'מעוז', 'נווה גדיד', 'נזר שומרון', 'עיבל', 'תמרה'
].map(s => s.trim()).filter(Boolean));

class ShippingAddressManager {
  constructor() {
    this.modal = null;
    this.form = null;
    this.addressData = null;
    this.citiesData = [];
    this.streetsData = {};
    this.currentCity = null;
    this.isProcessingCheckout = false;
    
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  async setup() {
    this.modal = document.getElementById('shipping-address-modal');
    this.form = document.getElementById('shipping-address-form');
    
    if (!this.modal || !this.form) {
      console.error('Shipping address modal or form not found');
      return;
    }

    this.loadAddress();
    this.setupEventListeners();
    await this.loadCitiesData();
    this.updateAddressDisplays();
    this.interceptCheckout();
  }

  setupEventListeners() {
    const closeBtn = this.modal.querySelector('.shipping-modal__close');
    const cancelBtn = this.modal.querySelector('.shipping-modal__cancel');
    const overlay = this.modal.querySelector('.shipping-modal__overlay');
    
    if (closeBtn) closeBtn.addEventListener('click', () => this.closeModal());
    if (cancelBtn) cancelBtn.addEventListener('click', () => this.closeModal());
    if (overlay) overlay.addEventListener('click', () => this.closeModal());

    this.form.addEventListener('submit', (e) => this.handleSubmit(e));

    // City input events
    const cityInput = document.getElementById('shipping-city');
    if (cityInput) {
      cityInput.addEventListener('input', (e) => {
        this.handleCityInput(e);
        this.updateNonDeliveryUI();
      });
      cityInput.addEventListener('focus', (e) => {
        if (e.target.value.trim().length >= 2) {
          this.handleCityInput(e);
        }
      });
      cityInput.addEventListener('change', async (e) => {
        const cityName = e.target.value.trim();
        const streetInput = document.getElementById('shipping-street');
        if (cityName && streetInput) {
          streetInput.disabled = false;
          streetInput.placeholder = 'התחל להקליד שם רחוב';
          await this.loadStreetsForCity(cityName);
        }
        this.updateNonDeliveryUI();
      });
      cityInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          const suggestions = document.getElementById('city-suggestions');
          if (suggestions && suggestions.classList.contains('active')) {
            const firstItem = suggestions.querySelector('.address-suggestion-item');
            if (firstItem) {
              e.preventDefault();
              cityInput.value = firstItem.getAttribute('data-value');
              this.hideSuggestions('city');
              const streetInput = document.getElementById('shipping-street');
              if (streetInput) {
                streetInput.disabled = false;
                streetInput.placeholder = 'התחל להקליד שם רחוב';
                this.loadStreetsForCity(cityInput.value);
              }
              this.updateNonDeliveryUI();
            }
          }
        }
      });
    }

    // Street input events
    const streetInput = document.getElementById('shipping-street');
    if (streetInput) {
      streetInput.addEventListener('input', (e) => this.handleStreetInput(e));
      streetInput.addEventListener('focus', (e) => {
          if (e.target.value.trim().length >= 2) {
            this.handleStreetInput(e);
        }
      });
      streetInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          const suggestions = document.getElementById('street-suggestions');
          if (suggestions && suggestions.classList.contains('active')) {
            const firstItem = suggestions.querySelector('.address-suggestion-item');
            if (firstItem) {
              e.preventDefault();
              streetInput.value = firstItem.getAttribute('data-value');
              this.hideSuggestions('street');
            }
          }
        }
      });
    }

    // Numeric field validation
    const numericFields = ['shipping-house-number', 'shipping-apartment', 'shipping-floor'];
    numericFields.forEach(fieldId => {
      const field = document.getElementById(fieldId);
      if (field) {
        field.addEventListener('input', (e) => {
          e.target.value = e.target.value.replace(/[^0-9]/g, '');
        });
      }
    });

    // Close suggestions when clicking outside
    document.addEventListener('click', (e) => {
      const cityInput = document.getElementById('shipping-city');
      const citySuggestions = document.getElementById('city-suggestions');
      const streetInput = document.getElementById('shipping-street');
      const streetSuggestions = document.getElementById('street-suggestions');
      
      if (cityInput && citySuggestions && 
          !cityInput.contains(e.target) && 
          !citySuggestions.contains(e.target)) {
        this.hideSuggestions('city');
      }

      if (streetInput && streetSuggestions && 
          !streetInput.contains(e.target) && 
          !streetSuggestions.contains(e.target)) {
        this.hideSuggestions('street');
      }
    });
  }

  async loadCitiesData() {
    try {
      const callbackName = 'citiesCallback_' + Date.now();
      const url = `https://data.gov.il/api/3/action/datastore_search?resource_id=5c78e9fa-c2e2-4771-93ff-7f400a12f7ba&limit=32000&sort=${encodeURIComponent('שם_ישוב asc')}&callback=${callbackName}`;
      
      console.log(`📡 טוען ערים עם JSONP...`);
      
      const data = await new Promise((resolve, reject) => {
        window[callbackName] = (data) => {
          delete window[callbackName];
          document.body.removeChild(script);
          resolve(data);
        };
        
        const script = document.createElement('script');
        script.src = url;
        script.onerror = () => {
          delete window[callbackName];
          if (script.parentNode) document.body.removeChild(script);
          reject(new Error('Failed to load cities'));
        };
        
        document.body.appendChild(script);
        
        setTimeout(() => {
          if (window[callbackName]) {
            delete window[callbackName];
            if (script.parentNode) document.body.removeChild(script);
            reject(new Error('Timeout loading cities'));
          }
        }, 15000);
      });
      
      if (data.success && data.result && data.result.records) {
        const unique = new Map();
        data.result.records.forEach(record => {
          const name = (record['שם_ישוב'] || '').trim();
          const code = record['סמל_ישוב'] || '';
          if (name && !unique.has(name)) {
            unique.set(name, { name, code });
          }
        });
        
        this.citiesData = Array.from(unique.values()).sort((a, b) => 
          a.name.localeCompare(b.name, 'he')
        );
        
        console.log(`✅ נטענו ${this.citiesData.length} ערים מ-API`);
      }
    } catch (error) {
      console.error('❌ שגיאה בטעינת ערים מ-API:', error);
      this.citiesData = [];
    }
  }


  async loadStreetsForCity(cityName) {
    // Only use cache if it has streets
    if (this.streetsData[cityName] && this.streetsData[cityName].length > 0) {
      console.log(`♻️ שימוש מחדש ב-${this.streetsData[cityName].length} רחובות (cache) עבור ${cityName}`);
      return this.streetsData[cityName];
    }

    console.log(`\n🔍 ====== טוען רחובות עבור: "${cityName}" ======`);
    
    // Try multiple city name variations
    const cityVariations = [
      cityName,
      cityName.replace(' - ', '-'),
      cityName.replace('- ', '-'),
      cityName.replace(' -', '-'),
      cityName.replace(/\s+/g, ' ').trim()
    ];
    
    for (const cityVar of cityVariations) {
      try {
        console.log(`🔍 מנסה וריאציה: "${cityVar}"`);
        
        // Use JSONP to avoid CORS issues
        const result = await this.fetchWithJSONP(cityVar);
        
        if (result && result.length > 0) {
          this.streetsData[cityName] = result;
          console.log(`✅ הצלחה! טענתי ${this.streetsData[cityName].length} רחובות`);
          console.log(`📋 5 רחובות ראשונים:`, this.streetsData[cityName].slice(0, 5));
          console.log(`====== סיום טעינה ======\n`);
          return this.streetsData[cityName];
      }
    } catch (error) {
        console.log(`❌ שגיאה בוריאציה "${cityVar}":`, error.message);
      }
    }
    
    console.log(`⚠️ לא נמצאו רחובות - ניתן להזין ידנית`);
    console.log(`====== סיום טעינה ======\n`);
    
    return [];
  }

  fetchWithJSONP(cityName) {
    return new Promise((resolve, reject) => {
      const callbackName = 'jsonpCallback_' + Date.now() + '_' + Math.random().toString(36).substr(2);
      
      // Use q parameter (free text search) instead of filters
      const url = `https://data.gov.il/api/3/action/datastore_search?resource_id=a7296d1a-f8c9-4b70-96c2-6ebb4352f8e3&q=${encodeURIComponent(cityName)}&limit=32000&callback=${callbackName}`;
      
      console.log(`📡 JSONP URL (q search): ${url}`);
      
      window[callbackName] = (data) => {
        delete window[callbackName];
        if (script.parentNode) document.body.removeChild(script);
        
        console.log(`📥 JSONP Success:`, data.success);
        console.log(`📊 Total Records:`, data.result?.records?.length || 0);
        
        if (data.success && data.result && data.result.records && data.result.records.length > 0) {
          console.log(`📋 דוגמת רשומות:`, data.result.records.slice(0, 3));
          
          // Filter to match exact city name
          const cityRecords = data.result.records.filter(record => {
            const recordCity = (record['שם_ישוב'] || '').trim();
            return recordCity === cityName || 
                   recordCity.includes(cityName) || 
                   cityName.includes(recordCity);
          });
          
          console.log(`🔍 רשומות מסוננות לעיר "${cityName}":`, cityRecords.length);
          
          if (cityRecords.length > 0) {
            const unique = new Map();
            cityRecords.forEach(record => {
              const name = (record['שם_רחוב'] || '').trim();
              if (name && !unique.has(name)) {
                unique.set(name, record);
              }
            });
            
            const streets = Array.from(unique.values())
              .map(r => r['שם_רחוב'])
              .sort((a, b) => a.localeCompare(b, 'he'));
            
            resolve(streets);
          } else {
            console.log(`⚠️ לא נמצאו רשומות תואמות אחרי סינון`);
            resolve([]);
          }
        } else {
          console.log(`❌ אין רשומות בתגובה`);
          resolve([]);
        }
      };
      
      const script = document.createElement('script');
      script.src = url;
      script.onerror = () => {
        delete window[callbackName];
        if (script.parentNode) document.body.removeChild(script);
        reject(new Error('JSONP request failed'));
      };
      
      document.body.appendChild(script);
      
      setTimeout(() => {
        if (window[callbackName]) {
          delete window[callbackName];
          if (script.parentNode) document.body.removeChild(script);
          reject(new Error('JSONP timeout'));
        }
      }, 10000);
    });
  }


  handleCityInput(e) {
    const value = e.target.value.trim();
    
    if (value.length < 2) {
      this.hideSuggestions('city');
      return;
    }
    
    const matches = this.citiesData
      .filter(city => city.name.includes(value))
      .slice(0, 10)
      .map(city => city.name);
    
    if (matches.length > 0) {
      this.showSuggestions('city', matches);
    } else {
      this.hideSuggestions('city');
    }
  }

  async handleStreetInput(e) {
    const value = e.target.value.trim();
    const cityInput = document.getElementById('shipping-city');
    
    if (!cityInput || !cityInput.value.trim()) {
      this.hideSuggestions('street');
      return;
    }

    if (value.length < 2) {
      this.hideSuggestions('street');
      return;
    }
    
    const cityName = cityInput.value.trim();
    const streets = await this.loadStreetsForCity(cityName);
    
    if (!streets || streets.length === 0) {
      this.hideSuggestions('street');
      return;
    }
    
    const startsWithMatches = streets.filter(street => street.startsWith(value));
    const containsMatches = streets.filter(street => 
      street.includes(value) && !street.startsWith(value)
    );
    
    const matches = [...startsWithMatches, ...containsMatches].slice(0, 15);
    
    if (matches.length > 0) {
      this.showSuggestions('street', matches);
    } else {
      this.hideSuggestions('street');
    }
  }


  showSuggestions(type, suggestions) {
    const containerId = type === 'city' ? 'city-suggestions' : 'street-suggestions';
    const container = document.getElementById(containerId);
    
    if (!container || suggestions.length === 0) {
      this.hideSuggestions(type);
      return;
    }

    container.innerHTML = suggestions.map(suggestion => 
      `<div class="address-suggestion-item" data-value="${suggestion}">${suggestion}</div>`
    ).join('');

    container.classList.add('active');

    container.querySelectorAll('.address-suggestion-item').forEach(item => {
      item.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const inputId = type === 'city' ? 'shipping-city' : 'shipping-street';
        const input = document.getElementById(inputId);
        if (input) {
          const selectedValue = item.getAttribute('data-value');
          input.value = selectedValue;
          this.hideSuggestions(type);
          
          if (type === 'city') {
            const streetInput = document.getElementById('shipping-street');
            if (streetInput) {
              streetInput.disabled = false;
              streetInput.placeholder = 'התחל להקליד שם רחוב';
            }
            await this.loadStreetsForCity(selectedValue);
            this.updateNonDeliveryUI();
          }
        }
      });

      item.addEventListener('touchend', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const inputId = type === 'city' ? 'shipping-city' : 'shipping-street';
        const input = document.getElementById(inputId);
        if (input) {
          const selectedValue = item.getAttribute('data-value');
          input.value = selectedValue;
          this.hideSuggestions(type);
          
          if (type === 'city') {
            const streetInput = document.getElementById('shipping-street');
            if (streetInput) {
              streetInput.disabled = false;
              streetInput.placeholder = 'התחל להקליד שם רחוב';
            }
            await this.loadStreetsForCity(selectedValue);
            this.updateNonDeliveryUI();
          }
        }
      });
    });
  }

  hideSuggestions(type) {
    const containerId = type === 'city' ? 'city-suggestions' : 'street-suggestions';
    const container = document.getElementById(containerId);
    if (container) {
      container.classList.remove('active');
      container.innerHTML = '';
    }
  }

  isNonDeliveryCity(cityName) {
    if (!cityName || typeof cityName !== 'string') return false;
    const trimmed = cityName.trim();
    if (!trimmed) return false;
    if (NON_DELIVERY_SET.has(trimmed)) return true;
    const withoutParentheses = trimmed.replace(/\s*\([^)]*\)\s*$/, '').trim();
    return NON_DELIVERY_SET.has(withoutParentheses);
  }

  updateNonDeliveryUI() {
    const cityInput = document.getElementById('shipping-city');
    const messageEl = document.getElementById('shipping-no-delivery-message');
    const submitBtn = document.getElementById('shipping-address-submit');
    const cityName = cityInput ? cityInput.value.trim() : '';
    const isNonDelivery = this.isNonDeliveryCity(cityName);

    if (messageEl) {
      messageEl.style.display = isNonDelivery ? 'block' : 'none';
    }
    if (submitBtn) {
      submitBtn.disabled = isNonDelivery;
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    const formData = new FormData(this.form);
    const cityValue = (formData.get('city') || '').trim();
    const streetValue = (formData.get('street') || '').trim();

    if (this.isNonDeliveryCity(cityValue)) {
      this.updateNonDeliveryUI();
      return;
    }

    if (!cityValue || cityValue === '') {
      alert('נא להזין שם עיר');
      return;
    }

    if (!streetValue || streetValue === '') {
      alert('נא להזין שם רחוב');
      return;
    }

    const address = {
      name: formData.get('name'),
      city: cityValue,
      street: streetValue,
      houseNumber: formData.get('houseNumber'),
      apartment: formData.get('apartment') || '',
      floor: formData.get('floor') || '',
      entrance: formData.get('entrance') || ''
    };

    this.saveAddress(address);
    this.updateAddressDisplays();
    this.showSuccessMessage();
    this.closeModal();
    
    if (window.location.pathname.includes('/cart')) {
      this.proceedToCheckout();
    }
  }

  showSuccessMessage() {
    const notification = document.createElement('div');
    notification.className = 'shipping-success-notification';
    notification.innerHTML = `
      <div class="shipping-success-content">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
          <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
        <div class="shipping-success-text">
          <strong>הכתובת נשמרה בהצלחה!</strong>
          <p>בדף התשלום הבא תתבקש למלא כתובת שוב לצורכי אימות ותשלום.</p>
        </div>
      </div>
    `;
    
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.classList.add('show');
    }, 100);
    
    setTimeout(() => {
      notification.classList.remove('show');
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 6000);
  }

  saveAddress(address) {
    this.addressData = address;
    localStorage.setItem('shippingAddress', JSON.stringify(address));
  }

  loadAddress() {
    const stored = localStorage.getItem('shippingAddress');
    if (stored) {
      try {
        this.addressData = JSON.parse(stored);
      } catch (error) {
        console.error('Error parsing stored address:', error);
        this.addressData = null;
      }
    }
  }

  getFormattedAddress() {
    if (!this.addressData) return null;

    return [
      this.addressData.city || '',
      this.addressData.street || '',
      this.addressData.houseNumber || '',
      this.addressData.entrance || '',
      this.addressData.apartment || '',
      this.addressData.floor || ''
    ].join('|');
  }

  getFormattedAddressForDisplay() {
    if (!this.addressData) return null;

    const parts = [
      this.addressData.street,
      this.addressData.houseNumber
    ];

    if (this.addressData.entrance) parts.push(`כניסה ${this.addressData.entrance}`);
    if (this.addressData.apartment) parts.push(`דירה ${this.addressData.apartment}`);
    if (this.addressData.floor) parts.push(`קומה ${this.addressData.floor}`);
    
    return `${parts.join(' ')}, ${this.addressData.city}`;
  }

  updateAddressDisplays() {
    const displays = document.querySelectorAll('.shipping-address-display');
    
    displays.forEach(display => {
      if (this.addressData) {
        const formattedAddress = this.getFormattedAddressForDisplay();
        display.innerHTML = `
          <div class="shipping-address-info">
            <div class="shipping-address-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
            </div>
            <div class="shipping-address-text">
              <div class="shipping-address-label">כתובת משלוח:</div>
              <div class="shipping-address-value">${formattedAddress}</div>
              <div class="shipping-address-name">${this.addressData.name}</div>
            </div>
            <button type="button" class="shipping-address-edit" data-edit-address>
              ערוך
            </button>
          </div>
        `;
        display.classList.add('has-address');
      } else {
        display.innerHTML = `
          <div class="shipping-address-info shipping-address-info--empty">
            <div class="shipping-address-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 22s-8-4.5-8-11.8A8 8 0 0 1 12 2a8 8 0 0 1 8 8.2c0 7.3-8 11.8-8 11.8z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
            </div>
            <div class="shipping-address-text">
              <div class="shipping-address-label">נא להוסיף כתובת משלוח</div>
              <button type="button" class="link-primary" data-open-address-modal>
                הוסף כתובת
              </button>
            </div>
          </div>
        `;
        display.classList.remove('has-address');
      }
    });

    document.querySelectorAll('[data-edit-address]').forEach(btn => {
      btn.addEventListener('click', () => this.openModal(true));
    });

    document.querySelectorAll('[data-open-address-modal]').forEach(btn => {
      btn.addEventListener('click', () => this.openModal());
    });
  }

  async openModal(edit = false) {
    if (!this.modal) return;

    if (edit && this.addressData) {
      document.getElementById('shipping-name').value = this.addressData.name || '';
      document.getElementById('shipping-city').value = this.addressData.city || '';
      document.getElementById('shipping-street').value = this.addressData.street || '';
      document.getElementById('shipping-house-number').value = this.addressData.houseNumber || '';
      document.getElementById('shipping-apartment').value = this.addressData.apartment || '';
      document.getElementById('shipping-floor').value = this.addressData.floor || '';
      document.getElementById('shipping-entrance').value = this.addressData.entrance || '';
      
      if (this.addressData.city) {
        await this.loadStreetsForCity(this.addressData.city);
        const streetInput = document.getElementById('shipping-street');
        if (streetInput) {
          streetInput.disabled = false;
          streetInput.placeholder = 'התחל להקליד שם רחוב';
        }
      }
      this.updateNonDeliveryUI();
    } else {
      this.form.reset();
      this.updateNonDeliveryUI();
    }

    this.modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  closeModal() {
    if (!this.modal) return;
    
    this.modal.style.display = 'none';
    document.body.style.overflow = '';
    this.form.reset();
    this.hideSuggestions('city');
    this.hideSuggestions('street');
  }

  interceptCheckout() {
    document.addEventListener('click', async (e) => {
      const checkoutBtn = e.target.closest('button[name="checkout"]');
      
      if (checkoutBtn) {
        if (this.isProcessingCheckout) {
          return true;
        }

        if (!this.addressData) {
          e.preventDefault();
          e.stopPropagation();
          this.openModal();
          return false;
        }
        
        e.preventDefault();
        e.stopPropagation();
        
        // Store checkout button for later
        this.pendingCheckoutButton = checkoutBtn;
        
        // Show confirmation modal
        this.showCheckoutConfirmation();
        
        return false;
      }
    }, true);
  }

  async proceedWithCheckout() {
    this.isProcessingCheckout = true;
    
        await this.addAddressToCart();
        
    const checkoutBtn = this.pendingCheckoutButton;
    const form = checkoutBtn?.closest('form');
    
        if (form) {
          const checkoutInput = document.createElement('input');
          checkoutInput.type = 'hidden';
          checkoutInput.name = 'checkout';
          checkoutInput.value = '';
          form.appendChild(checkoutInput);
          
            form.submit();
        } else {
            window.location.href = '/checkout';
    }
  }

  showCheckoutConfirmation() {
    const modal = document.createElement('div');
    modal.className = 'shipping-confirmation-modal';
    modal.style.display = 'flex';
    
    const formattedAddress = this.getFormattedAddressForDisplay();
    
    modal.innerHTML = `
      <div class="shipping-confirmation-overlay"></div>
      <div class="shipping-confirmation-content">
        <div class="shipping-confirmation-header">
          <h2>אישור כתובת המשלוח</h2>
        </div>
        <div class="shipping-confirmation-body">
          <p class="shipping-confirmation-question">האם הכתובת הבאה נכונה?</p>
          <div class="shipping-confirmation-address">${formattedAddress}</div>
          <p class="shipping-confirmation-info">ההזמנה תישלח לכתובת זו</p>
        </div>
        <div class="shipping-confirmation-actions">
          <button type="button" class="button button--secondary shipping-confirmation-cancel">
            ביטול
          </button>
          <button type="button" class="button button--outline shipping-confirmation-edit">
            ערוך כתובת
          </button>
          <button type="button" class="button button--primary shipping-confirmation-confirm">
            אישור ומעבר לתשלום
          </button>
        </div>
      </div>
    `;
    
    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';
    
    const overlay = modal.querySelector('.shipping-confirmation-overlay');
    const cancelBtn = modal.querySelector('.shipping-confirmation-cancel');
    const confirmBtn = modal.querySelector('.shipping-confirmation-confirm');
    
    const closeModal = () => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
      modal.remove();
      this.isProcessingCheckout = false;
    };
    
    const editBtn = modal.querySelector('.shipping-confirmation-edit');
    
    overlay.addEventListener('click', closeModal);
    cancelBtn.addEventListener('click', closeModal);
    
    editBtn.addEventListener('click', () => {
      closeModal();
      this.openModal(true);
    });
    
    confirmBtn.addEventListener('click', async () => {
      confirmBtn.disabled = true;
      confirmBtn.textContent = 'מעביר לתשלום...';
      
      modal.style.display = 'none';
      document.body.style.overflow = '';
      modal.remove();
      
      await this.proceedWithCheckout();
    });
    
    setTimeout(() => {
      modal.classList.add('show');
    }, 10);
  }

  async addAddressToCart() {
    if (!this.addressData) return;

    try {
      const attributes = {
        'Shipping Name': this.addressData.name,
        'Shipping City': this.addressData.city,
        'Shipping Street': this.addressData.street,
        'Shipping House Number': this.addressData.houseNumber,
        'Shipping Full Address': this.getFormattedAddress()
      };

      if (this.addressData.apartment) {
        attributes['Shipping Apartment'] = this.addressData.apartment;
      }
      if (this.addressData.floor) {
        attributes['Shipping Floor'] = this.addressData.floor;
      }
      if (this.addressData.entrance) {
        attributes['Shipping Entrance'] = this.addressData.entrance;
      }

      console.log('Sending address to cart:', attributes);

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: attributes
        })
      });

      if (!response.ok) {
        console.error('Failed to update cart with address');
        return false;
      }

      const result = await response.json();
      console.log('Cart updated successfully:', result);

      await this.saveAsCustomerAddress();
      
      return true;
    } catch (error) {
      console.error('Error adding address to cart:', error);
      return false;
    }
  }

  async saveAsCustomerAddress() {
    if (!window.Shopify || !window.Shopify.customer) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append('address[first_name]', this.addressData.name.split(' ')[0] || this.addressData.name);
      formData.append('address[last_name]', this.addressData.name.split(' ').slice(1).join(' ') || '');
      formData.append('address[address1]', `${this.addressData.street} ${this.addressData.houseNumber}`);
      formData.append('address[address2]', `דירה ${this.addressData.apartment || ''} קומה ${this.addressData.floor || ''} כניסה ${this.addressData.entrance || ''}`.trim());
      formData.append('address[city]', this.addressData.city);
      formData.append('address[country]', 'Israel');
      formData.append('address[zip]', '');
      formData.append('address[phone]', '');
      formData.append('utf8', '✓');

      const metaToken = document.querySelector('meta[name="csrf-token"]');
      if (metaToken) {
        formData.append('authenticity_token', metaToken.content);
      }

      console.log('Attempted to save customer address');
    } catch (error) {
      console.log('Could not save as customer address:', error);
    }
  }

  proceedToCheckout() {
    const checkoutForm = document.querySelector('form[action*="/cart"]');
    if (checkoutForm) {
      const checkoutButton = checkoutForm.querySelector('button[name="checkout"]');
      if (checkoutButton) {
        setTimeout(() => {
          checkoutButton.click();
        }, 300);
      }
    }
  }
}

// Initialize the manager
const shippingManager = new ShippingAddressManager();
window.shippingAddressManager = shippingManager;
